// extracted by mini-css-extract-plugin
export default {"card":"j_-z"};